export default {
	tableOfContents: "Inhaltsverzeichnis",
} as const;
